import React, { useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, DatePicker, Card } from 'antd';
import Input from '../../../ui/Input';
import ActionButtonsBar from '../../../ui/ActionButtonsBar';
import { LocalPersistence, ApiCallsFactory } from '../../../../factories';
import moment from 'moment';
import PageContainer from '../../../CSIComponents/PageContainer';
import Loading from '../../../Loading';
import { disableContent } from '../../../../helpers/misc/disableContent';

const dateFormat = 'MM/DD/YYYY';
const { RangePicker } = DatePicker;
declare global {
  interface Window {
    closuresAdd: boolean;
  }
}

const AddClosure = (props: any) => {
  const [form] = Form.useForm();
  const [addLoading, setAddLoading] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [dateRange, setDateRange] = useState<null | any>(null);
  const [disabledSave, setDisabledSave] = useState<boolean>(false);

  function validation() {
    const rangeText = /^(.){0,128}$/;
    if (rangeText.test(name) && dateRange !== null) {
      return (window.closuresAdd = true);
    }
    return (window.closuresAdd = false);
  }

  const watcher = async () => {
    const saveBtn: any = document.querySelectorAll('[data-test="save-btn"]');
    // save button functionality
    if (window.closuresAdd) {
      for (let i = 0; i < saveBtn.length; i++) {
        saveBtn[i]?.classList?.remove('is-disabled');
      }
    } else {
      for (let i = 0; i < saveBtn.length; i++) {
        saveBtn[i]?.classList?.add('is-disabled');
      }
    }
  };

  useEffect(() => {
    disableContent();
    // adding listeners
    window.addEventListener('input', () => {
      watcher();
    });
    window.addEventListener('change', () => {
      watcher();
    });
    window.addEventListener('click', () => {
      watcher();
    });
    window.addEventListener('mousemove', () => {
      watcher();
    });
    // disabled the save button
    validation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    validation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, dateRange]);

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const addSave = () => {
    setDisabledSave(true);
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session');
      const session: any = await get_session.getSessionPersistence();
      const body = {
        supplier: session.supplier,
        propertyId: session.propertyId,
        property: {
          closures: [
            {
              name: value.closurename,
              startdate:
                (value.dateRange[0] &&
                  moment(value.dateRange[0]).format(dateFormat)) ||
                '',
              enddate:
                (value.dateRange[1] &&
                  moment(value.dateRange[1]).format(dateFormat)) ||
                '',
            },
          ],
        },
      };
      try {
        // post
        const basicInfoUpdated = new ApiCallsFactory(
          '/basicinformation/closures',
          session.token,
          body
        );
        await basicInfoUpdated.postData();
        setAddLoading(true);
        setAddLoading(false);
        form.resetFields();
        props.cancelAddAndEdit();
      } catch (error) {
        throw new Error('Something were wrong');
      }
    });
  };

  if (addLoading) return <Loading type="large" />;
  return (
    <PageContainer>
      <Card style={{ marginTop: 0 }}>
        <Grid
          container
          spacing={0}
          className="containerSpacing py-0"
        >
          <Grid
            item
            xs={12}
            className="p-0"
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                Closure Name
              </div>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            className="pb-0 px-0 my-0"
          >
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Closure Name"
                    name="closurename"
                    rules={[
                      {
                        max: 128,
                        message:
                          'You have reached the max character length of 128',
                      },
                    ]}
                  >
                    <Input
                      maxLength={128}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Start Date ~ End Date"
                    name="dateRange"
                    rules={[
                      { required: true, message: 'This field is required' },
                    ]}
                  >
                    <RangePicker
                      format={dateFormat}
                      onChange={(e) => setDateRange(e)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onCancel={() => {
          props.cancelAddAndEdit();
          form.resetFields();
        }}
        onSave={addSave}
        disabledSave={disabledSave}
      />
    </PageContainer>
  );
};

export default AddClosure;
